import React from 'react'
import { Col, Row } from 'antd'
import { useTranslation } from 'lib/i18n'

import BlogBreadcrumbs from 'components/BlogBreadcrumbs/BlogBreadcrumbs'
import CmsPage from 'components/CmsPage/CmsPage'
import Heading from 'components/Heading/Heading'
import Wrapper from 'components/Wrapper/Wrapper'

const BlogPage: React.FC = () => {
  const { t } = useTranslation()

  return (
    <Wrapper>
      <Row gutter={24}>
        <Col
          xs={24}
          sm={{ span: 15 }}
          md={{ span: 16 }}
          lg={{ span: 20, offset: 2 }}
        >
          <Heading level="h2">
            <h1>{t('BlogPost.heading', 'memmo Blog')}</h1>
          </Heading>

          <BlogBreadcrumbs />

          <Row gutter={24}>
            <CmsPage slug="blog" />
          </Row>
        </Col>
      </Row>
    </Wrapper>
  )
}

export default BlogPage
